const userProfileEndpoints = {
  VIEW_PROFILE: 'loopay-user-management/profile',
  CHANGE_PASSWORD: 'loopay-user-management/auth/change-password',
} as const;

export default userProfileEndpoints;
